export const MODULE_NAME = 'notification';

const prefix = `${MODULE_NAME}/`;

export const ACTION_TYPES = {
    NOTIFICATION_PUSHED: `${prefix}NOTIFICATION_PUSHED`,
    NOTIFICATION_REMOVED: `${prefix}NOTIFICATION_REMOVED`
};
